<template>
  <nav v-show="isShow" class="context-menu">
    <ul class="context-menu__items">
      <li class="context-menu__item" @click="fnregisterForm">
        <a class="context-menu__link"> In phiếu đăng ký </a>
      </li>
    </ul>
  </nav>
</template>

<script>
// import { exportRegistrationFormApi } from '@/api/export_service/exportService'
// import { notifyError } from '@/utils/toast'
// import { openPdfWindow } from '@/utils/file-handler'
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    data: {
      required: true
    }
  },
  data() {
    return {
      mappingType: {
        'Khách lẻ': 3,
        Nhóm: 1,
        Đoàn: 2
      }
    }
  },
  mounted() {},
  methods: {
    fnregisterForm() {
      const routeData = this.$router.resolve({
        path: '/group/register_form',
        query: {
          id: this.data.room_booking_code || this.data.booking_code,
          type: this.mappingType[this.data.traveller_type]
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
/* context menu */

.context-menu {
  // display: none;
  position: absolute;
  z-index: 10;
  padding: 8px 0;
  width: 320px;
  background-color: #fff;
  border: solid 1px #dfdfdf;
  box-shadow: 1px 1px 2px #cfcfcf;
  font-size: 14px;
}

.context-menu--active {
  display: block;
}

.context-menu__items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu__item {
  display: block;
  margin-bottom: 4px;
}

.context-menu__item:last-child {
  margin-bottom: 0;
}

.context-menu__link {
  display: block;
  padding: 4px 12px;
  color: #25a366;
  text-decoration: none;
}

.context-menu__link:hover {
  color: #fff;
  background-color: #25a366;
}
</style>
